import React from 'react';
import InputField from '../../../Forms/Input/InputField';

interface OtherPaymentSectionProps {
  voucherCode: string;
  onVoucherChange: (value: string) => void;
}

const OtherPaymentSection: React.FC<OtherPaymentSectionProps> = ({
  voucherCode,
  onVoucherChange,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onVoucherChange(e.target.value);
  };

  return (
    <div className="grid gap-4 sm:grid-cols-2">
      <InputField
        label="Referencia (Otros)"
        name="otherPaymentVoucher"
        iconKey="payment" // usa el icono que tengas disponible
        type="text"
        placeholder="Ingrese la referencia del pago"
        value={voucherCode}
        onChange={handleChange}
      />
    </div>
  );
};

export default OtherPaymentSection;
